import React, { ReactNode } from 'react';
import { CalendarProps, Calendar } from './Calendar';
import { Dropdown } from './Dropdown';

interface DatePickerProps extends CalendarProps {
    children?: ReactNode;
    isOpen?: boolean;
}

export function DatePicker(props: DatePickerProps) {
    return <Dropdown children={props.children} isOpen={props.isOpen} menu={<Calendar {...props} />} />;
}
